import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

const DEMO_SESSIONS = [
  {
    id: 'sess-001',
    user_id: 42,
    ip_address: '192.168.1.100',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Chrome/125.0',
    created_at: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    last_active_at: new Date().toISOString(),
    is_current: true,
  },
  {
    id: 'sess-002',
    user_id: 42,
    ip_address: '10.0.0.45',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_4) Safari/604.1',
    created_at: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString(),
    last_active_at: new Date(Date.now() - 6 * 3600 * 1000).toISOString(),
    is_current: false,
  },
  {
    id: 'sess-003',
    user_id: 42,
    ip_address: '172.16.0.12',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/126.0',
    created_at: new Date(Date.now() - 7 * 24 * 3600 * 1000).toISOString(),
    last_active_at: new Date(Date.now() - 3 * 24 * 3600 * 1000).toISOString(),
    is_current: false,
  },
];

let sessions = [...DEMO_SESSIONS];

export const demoSessionsHandlers = [
  // ── List sessions ─────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/me/sessions`, () => {
    return HttpResponse.json(sessions);
  }),

  // ── Revoke single session ─────────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/me/sessions/:id`, ({ params }) => {
    const id = params['id'] as string;
    sessions = sessions.filter((s) => s.id !== id);
    return new HttpResponse(null, { status: 204 });
  }),

  // ── Revoke all sessions ───────────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/me/sessions`, () => {
    sessions = sessions.filter((s) => s.is_current);
    return new HttpResponse(null, { status: 204 });
  }),
];
